module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#instagram",
      toString: function () {
        return this.url;
      }
    }